import { jsx as e, jsxs as t } from "react/jsx-runtime";
//#region lib/Image/components/FigureByline.tsx
var n = ({ children: n, options: r }) => {
	let { bylineLabel: i } = r;
	return /* @__PURE__ */ t("div", {
		className: "p-2 flex rounded-xs text-sm bg-slate-100 dark:bg-slate-700",
		children: [/* @__PURE__ */ e("label", {
			className: "shrink-0 w-16 opacity-70",
			contentEditable: !1,
			children: `${i ?? "Photo"}:`
		}), /* @__PURE__ */ e("figcaption", {
			className: "grow",
			children: n
		})]
	});
};
//#endregion
export { n as FigureByline };
